import React from 'react';

import CashFlowModal from '../../../../boards/components/widget/cashflow/cashFlowModal/cashFlowModal';
import DocuSignLoadingModal from '../../../../ui/modal/docuSignLoadingModal/docuSignLoadingModal';
import MultipleDownloadModal from '../../../../ui/popup/multipleDownload/multipleDownload';
import SelectedDocsLimit from '../../../../ui/popup/selectedDocsLimit/selectedDocsLimit';
import ServerError from '../../../../ui/popup/serverError/serverError';
import ActionForbidden from '../../../../ui/modal/actionForbidden/actionForbidden';
import PdfDialog from '../../../../pdfPage/components/pdfDialog/pdfDialog';

const ModalWrapper: React.FC = () => {
  return (
    <>
      <CashFlowModal />
      <ActionForbidden />
      <DocuSignLoadingModal />
      <MultipleDownloadModal />
      <SelectedDocsLimit />
      <PdfDialog />
      <ServerError />
    </>
  );
};

export default ModalWrapper;